import type { PromoCode } from "@/models/PromoCode";
import { get as apiGet } from "./API";

export async function get() {
    return apiGet(`/promo-codes`, { requiresAuth: true }) as Promise<PromoCode[]>;
}